<template>
    <header>
        <router-link :to="{name: 'home-with-lang', params:{ lang }}" class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 65"><path fill-rule="evenodd" d="M55.07 61.72c-.26 1.11-5.36 4.04-12.45 1.77-3.32-1.07-1.21-11.6-2.7-13.5-1.16-1.48-11.14-3.17-14.39.1-2.03 2.04.06 12.43-4.3 13.7-6.45 1.87-7.8.24-8.79-.05-1.89-.54-4.05-.8-3.86-12.14.18-11.3 1.3-19.76 1.3-19.76s-4.36 3.08-7.34 2.54c-2.97-.54-4.34-2.61 1.6-12.33C10.09 12.31 30.62-1.94 34.41.22c5.21 2.97 15.44 8.87 25.27 22.58 4.65 6.48 6.39 14.69-1.81 11.02-3.74-1.68-3.64-1.96-3.64-1.96s2.22 24.04.84 29.87v-.01Z" clip-rule="evenodd"/></svg>
            <span class="sr-only">Accueil</span>
        </router-link>
    </header>

    <div class="page-box extras">
        <h1 class="page-box-title">Tu as <span class="notes-qty">{{score}} <SvgNote /></span></h1>

        <Tabs>

            <Tab title="Musiques">
                <Cards>
                    <template v-for="(item, i) in songs">
                        <Card
                            :label="item.name"
                            :image="`/images/${item.image}`"
                            :class="{ 'unavailable': score < item.cost, 'unlocked': item.unlocked, 'selected' : item.active }"
                            @click="() => select(songs, item)"
                        >
                            <template v-slot:header>
                                <p class="item-cost">Utiliser <span class="notes-qty">{{ item.cost }}<SvgNote /></span></p>
                            </template>
                            <template v-slot:button>
                                <button class="btn-primary btn-choose" @click="() => unlock(songs, item)">Choisir</button>
                            </template>
                        </Card>
                    </template>
                </Cards>
            </Tab>

            <Tab title="Personnages">
                <Cards>
                    <template v-for="(item, i) in characters">
                        <Card
                            :label="item.name"
                            :image="`/images/${item.image}`"
                            :class="{ 'unavailable': score < item.cost, 'unlocked': item.unlocked, 'selected' : item.active }"
                            @click="() => select(characters, item)"
                        >
                            <template v-slot:header>
                                <p class="item-cost">Utiliser <span class="notes-qty">{{ item.cost }}<SvgNote /></span></p>
                            </template>
                            <template v-slot:button>
                                <button class="btn-primary btn-choose" @click="() => unlock(characters, item)">Choisir</button>
                            </template>
                        </Card>
                    </template>
                </Cards>
            </Tab>

            <Tab title="Décors" class="decors">
                <Cards>
                    <template v-for="(item, i) in decors">
                        <Card
                            :label="item.name"
                            :image="`/images/${item.image}`"
                            :class="{ 'unavailable': score < item.cost, 'unlocked': item.unlocked, 'selected' : item.active }"
                            @click="() => select(decors, item)"
                        >
                            <template v-slot:header>
                                <p class="item-cost">Utiliser <span class="notes-qty">{{ item.cost }}<SvgNote /></span></p>
                            </template>
                            <template v-slot:button>
                                <button class="btn-primary btn-choose" @click="() => unlock(decors, item)">Choisir</button>
                            </template>
                        </Card>
                    </template>
                </Cards>
            </Tab>

        </Tabs>

    </div>

    <nav class="nav-prevnext">
        <router-link :to="previousPage" class="btn-icon prev">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 52"><path fill-rule="evenodd" d="M62.27 37.466c1.86-.44 3.28-2.89 2.52-9-.76-6.11.05-11.24-.49-13.15-.55-1.91-1.07-3.63-12.26-1.18s-19.96 4.95-19.96 4.95 3.11-13.5 2.56-16.5c-.55-3-2.63-4.38-12.46 1.62-9.82 6-24.22 20.38-22.04 24.2 3.001 5.27 8.95 10.14 22.8 20.07 6.55 4.7 11.95 5.27 11.13-1.82-.82-7.09-1.98-12.77-1.98-12.77s24.29 4.97 30.17 3.57l.01.01Z" clip-rule="evenodd"/></svg>
        </router-link>
    </nav>

    <Modal v-if="showModal">
        <template v-slot:content>
            <div v-html="modalContent"></div>
        </template>
    </Modal>
</template>

<script>
    import Cards from "../components/Cards";
    import Card from "../components/Card";
    import Modal from "../components/Modal";
    import SvgNote from "../components/SvgNote";
    import Tabs from "../components/Tabs";
    import Tab from "../components/Tab";

    export default {
        name: "Extras",
        components: { Cards, Card, Modal, SvgNote, Tabs, Tab }
    }
</script>

<script setup>
    import { computed, ref } from "vue";

    import { useMainStore }     from "../stores/main";
    import { storeToRefs }        from "pinia";

    let store = useMainStore();
    const { lang, score, showModal } = storeToRefs(store);

    let { getPreviousPage, songs, characters, decors, unlockItem, selectItem, openModal, closeModal } = store;
    let previousPage = computed ( () => getPreviousPage());

    const modalContent = ref('');

    const canBuy = function (item) {
        return !item.unlocked && score.value >= item.cost;
    }

    const getModalContent = function(cost) {
        if( score.value >= cost ) {
            return `<p>Veux-tu utiliser <span class="notes-qty">${cost}<SvgNote /></span> ?</p>`;
        } else {
            return `<p>Tu n'as pas assez de notes !</p>`;
        }
    }

    const unlock = function(items, item) {
        modalContent.value = getModalContent(item.cost);

        if(score.value >= item.cost) {
            // wait for confirmation and THEN do things
            openModal(($event) => handleBuyItem($event, items, item), closeModal);
        } else {
            openModal(false, closeModal);
        }
    }

    const handleBuyItem = function($event, items, item) {
        unlockItem(items, item);
        selectItem(items, item);
        closeModal();
    }

    const select = function(items, item) {
        if(!item.unlocked) return;
        selectItem(items, item);
    }
</script>
